import { contact } from '../data/contact';
import { author } from '../data/profile';
import type { ContactItem } from '../types';
import './Contact.css';

const isExternal = (href: string) => href.startsWith('http');

interface ContactRowProps {
  item: ContactItem;
}

function ContactRow({ item }: ContactRowProps) {
  const external = isExternal(item.href);
  return (
    <a
      className="contact-row"
      href={item.href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noreferrer' : undefined}
    >
      <span className="contact-label">
        <span className="contact-kbd">{item.kbd}</span>
        {item.label}
      </span>
      <span className="contact-value">{item.value}</span>
      <span className="contact-arrow" aria-hidden>→</span>
    </a>
  );
}

export function Contact() {
  return (
    <section className="contact" id="contact" aria-labelledby="contact-heading">
      <div className="contact-inner" data-reveal>
        <span className="section-index">08</span>
        <h2 id="contact-heading" className="contact-headline">
          Let's build <span className="contact-italic">something</span>
          <br />
          that lasts.
        </h2>

        <a className="contact-mega" href={`mailto:${author.email}`}>
          <span className="contact-mega-arrow" aria-hidden>↗</span>
          <span>{author.email}</span>
        </a>

        <div className="contact-grid">
          {contact.map((item) => (
            <ContactRow key={item.label} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
